module.exports = __webpack_public_path__ + "img/Girl_030015.c5e68986.png";